<template>

    <div class="container">

        <app-head title="Watchlist" />

        <div class="my-4">
            <h1>{{ __('Watchlist') }}</h1>
        </div>

        <div class="card mb-4 border-warning " v-if="updatedWatchlistItems.length > 0">
            <div class="card-header bg-warning">
                <i class="bi bi-exclamation-circle"></i>
                {{ __('Bitte beachten Sie, dass sich die Preise bei folgenden Produkten geändert haben') }}
            </div>
            <div class="card-body">
                <div v-for="updatedCartItem in updatedWatchlistItems">
                    <div class="row">
                        <div class="col-2">
                            <div class="small text-uppercase text-secondary">
                                {{ __('Lieferanten-Artikelnr.') }}
                            </div>
                            <div class="">
                                {{ updatedCartItem.product.supplier_pid }}
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="small text-uppercase text-secondary">
                                {{ __('Produkt') }}
                            </div>
                            <div>
                                {{ updatedCartItem.product_name }}
                            </div>
                        </div>
                        <div class="col-2">
                            <div class="small text-uppercase text-secondary">
                                {{ __('Bisheriger Preis') }}
                            </div>
                            <div class="fw-bold text-danger">
                                {{ updatedCartItem.previous_price | localizeAmount }}
                            </div>
                        </div>
                        <div class="col-2">
                            <div class="small text-uppercase text-secondary">
                                {{ __('Neuer Preis') }}
                            </div>
                            <div class="fw-bold text-success">
                                {{ updatedCartItem.price | localizeAmount }}
                            </div>
                        </div>
                    </div>
                    <hr>
                </div>
            </div>
        </div>

        <div class="d-flex flex-column align-items-start flex-lg-row align-items-lg-center bg-light border p-3 gap-3 gap-lg-5 mb-3">

            <search-filter v-model="form.search" class="" @reset="reset" :placeholder="__('Suche in Merkliste')">
            </search-filter>

            <div>
                <switch-input v-model="form.group" :label="__('Nach Lieferanten gruppieren')" class="mb-n3" />
            </div>

            <div class="d-flex gap-4 ms-lg-auto">

                <!--                <div class="nav-item">
                                    {{ __('Sortierung:') }}
                                </div>-->
                <div class="" v-for="option in sortByOptions">
                    <inertia-link :href="'?search=' + (form.search || '') + '&sort=' + option.column + '&direction=' + (form.direction === 'desc' ? 'asc' : 'desc')" :class="{'link-dark': form.sort === option.column}">
                        {{ option.label }}
                        <template v-if="form.sort === option.column">
                            <template v-if="form.direction === 'desc'">
                                <i class="bi bi-chevron-down"></i>
                            </template>
                            <template v-else>
                                <i class="bi bi-chevron-up"></i>
                            </template>
                        </template>
                        <template v-else>
                            <i class="bi bi-chevron-expand"></i>
                        </template>
                    </inertia-link>
                </div>

            </div>
        </div>

        <template v-if="items.length === 0">
            <div>
                {{ __('Noch keine Produkte auf der Merkliste.') }}
            </div>
        </template>

        <template v-else>

            <template v-if="filters.group">
                <div class="card mb-4" v-for="group in itemsBySupplier">
                    <div class="card-header">
                        <h3 class="h5 m-0">
                            <img class="" :src="group.supplier.logo" alt="" style="max-height: 40px; width: auto;" v-if="group.supplier.logo" />
                            <div v-else class="h3">
                                {{ group.supplier.name }}
                            </div>
                        </h3>
                    </div>
                    <div class="card-body">
                        <div class="row d-none d-lg-flex">
                            <div class="col-lg-1"></div>
                            <div class="col-lg-3">{{ __('Produkt') }}</div>
                            <div class="col-lg-1">{{ __('Einzelpreis') }}</div>
                            <div class="col-lg-2">{{ __('Hinzugefügt') }}</div>
                            <div class="col-lg-3">{{ __('Einkauf') }}</div>
                            <div class="col-lg-2"></div>
                        </div>
                        <hr />
                        <watchlist-item 
                            :item="item" 
                            v-for="item in group.watchlistItems" 
                            :key="item.id" 
                            />
                    </div>
                </div>
            </template>

            <template v-else>
                <div class="row d-none d-lg-flex">
                    <div class="col-lg-1"></div>
                    <div class="col-lg-3">{{ __('Produkt') }}</div>
                    <div class="col-lg-1">{{ __('Einzelpreis') }}</div>
                    <div class="col-lg-2">{{ __('Hinzugefügt') }}</div>
                    <div class="col-lg-3">{{ __('Einkauf') }}</div>
                    <div class="col-lg-2"></div>
                </div>
                <hr />
                <watchlist-item 
                    :item="item" 
                    v-for="item in items" 
                    :key="item.id" 
                    />
            </template>



            <div class="d-flex justify-content-between">
                <div>
                    <!--@todo extra controller method, ohne :data="{items: cartItems}"--> 
                    <inertia-link :href="route('cart.add-items')" 
                                  :data="{items: cartItems}" 
                                  method="post" 
                                  as="button" 
                                  class="btn btn-lg btn-outline-primary"
                                  v-if="$page.props.auth.user.can.add_cart_items">
                        <i class="bi bi-cart"></i>
                        {{ __('Alle Produkte in den Warenkorb legen') }}
                    </inertia-link>
                </div>
            </div>

        </template>
        
        <sticky-message :message="$page.props.flash.success" />

    </div>

</template>

<script>
    import WatchlistItem from './WatchlistItem';
    
    import StickyMessage from '@/shared/StickyMessage';
    import SearchFilter from '@/shared/SearchFilter';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import SwitchInput from '@/shared/Inputs/SwitchInput';

    export default {
        props: [
            'items',
            'itemsBySupplier',
            'updatedWatchlistItems',
            'filters',
        ],
        data() {
            return {
                form: {
                    search: this.filters.search,
                    group: this.filters.group,
                    sort: this.filters.sort,
                    direction: this.filters.direction,
                },
                sortByOptions: [
                    {
                        label: 'Alphabetisch',
                        column: 'product_name',
                    },
                    {
                        label: 'Preis',
                        column: 'price',
                    },
                    {
                        label: 'Datum',
                        column: 'created_at',
                    },
                ],
            }
        },
        components: {
            WatchlistItem,
            StickyMessage,
            SearchFilter,
            SelectInput,
            SwitchInput,
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('watchlist.index'), this.form, {preserveState: true, preserveScroll: true})
                }, 300, {trailing: true}),
            },
        },
        computed: {
            cartItems() {
                var cartItems = [];
                _.each(this.items, (o) => {
                    if (o.product) {
                        cartItems.push(o.product.id);
                    }
                });

                return cartItems;
            }
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
        },
    }
</script>